import {useLazyQuery, gql} from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getResortLocationArrival($hapimagResortId: Int!, $locale: String!){
   resortCollection(limit: 1, where: { hapimagResortId: $hapimagResortId }, locale: $locale) {
    items {
        arrivalLocation{,
        title,
        streetPostalCodeCityCountry,
        placesCollection{
              items{
                    name,
                    givenName,
                    distanceInMinutes,
                     placeClassification {
                        iconId,
                        text,
                        isStandaloneName
                     }
                    distanceToTheResort,
                    relatedMeansOfTransport {
                      iconId,
                      recommendation
                    }
              }
        },
        resortGooglePlaceId,
        tipp,
        resortParkingDetailsCollection {
          items {
            arrivalInfo
          }
        }
        resortTransfer {
          arrivalInfo
        }
      }
    }
   }
}`;

export const useResortLocationArrival = () => {
    const {logger} = useLogger();
    const [getResortLocationArrival, {loading, data, error}] = useLazyQuery(QUERY, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const arrivalLocationInfo = data?.resortCollection.items[0].arrivalLocation;

    if (error?.message) {
        logger(error?.message, "error", "useResortLocationArrival", error?.stack);
    }

    return {
        arrivalLocationInfo,
        getResortLocationArrival,
        arrivalLocationLoading: loading

    };
};
